import React, { useState } from "react";
import Logo from "../../images/logo1.1.png";
import LogoDark from "../../images/logo1.1.png";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import 'react-phone-input-2/lib/style.css'
import {
  Block,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
  Button,
  Icon,
  PreviewCard,
} from "../../components/Component";
import { Form, FormGroup, Spinner, Alert } from "reactstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

const CopyLogin = (props) => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");

  
    /*const styles = {
        width: "100%",
      
        fontSize: 18,
        height: "2em"



    }*/
  const onFormSubmit = async (formData) => {
      setLoading(true);
     
     
      const sendData = {
          OrgId: Number(2),
          LoginName: formData.username,
          Password: formData.passcode,
          VURL: window.location.href,
          WebHeader: 'MyProfileFile',


      }
     
      await fetch(process.env.REACT_APP_API_LINK+'api/Main/UserVerify3', {
          method: 'POST',
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(sendData)

      })
          .then(response => response.json())
          .then(
              data => {
                  //console.log(data)
                  if (data === "No") {
                      window.location.pathname = "/BlankPage"
                  } else {



                      if (data.firstName !== null) {
                          localStorage.setItem("accessToken", "token");
                          localStorage.setItem('orgId', 2);
                          if (data.urole === 16) {
                              localStorage.setItem('userId', data.userId)
                          } else {
                              localStorage.setItem('userIdA', data.userId)
                          }

                          localStorage.setItem('Maincatid', data.mainCatID);
                          localStorage.setItem('urole', data.urole);
                          localStorage.setItem('OrderNo', data.orderNo);
                          var page = data.urole === 7 ? '/Admin-Dashboard' : '/Dashboard'
                          // setTimeout(() => {
                          //     const target = `${process.env.PUBLIC_URL}${page}`;
                          //     window.history.pushState(target, "auth-login", target);
                          //     window.location.reload(); 
                          // }, 2000);

                          setTimeout(() => {
                              window.history.pushState(
                                  `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : page}`,
                                  "auth-login",
                                  `${process.env.PUBLIC_URL ? process.env.PUBLIC_URL : page}`
                              );
                              window.location.reload();
                          }, 2000);
                          
                      }

                      else {
                          setTimeout(() => {
                              setError("Cannot login with credentials");
                              setLoading(false);
                          }, 2000);
                      }
                  }



              })

    




  };

    const { errors, register, handleSubmit } = useForm();



  return (
    <React.Fragment>
      <Head title="Login" />

         
      <PageContainer>
        <Block className="nk-block-middle nk-auth-body  wide-xs">
          

                  <PreviewCard className="card-bordered" bodyClass="card-inner-lg">
                      <div className="brand-logo pb-4 text-center">
                          <Link to={process.env.PUBLIC_URL + "/"} className="logo-link">
                              <img className="logo-light logo-img logo-img-lg" src={Logo} alt="logo" />
                              <img className="logo-dark logo-img logo-img-lg" src={LogoDark} alt="logo-dark" />
                          </Link>
                      </div>
            <BlockHead>
              <BlockContent>
                <BlockTitle tag="h4">Login</BlockTitle>
                <BlockDes>
                  
                </BlockDes>
              </BlockContent>
            </BlockHead>
            {errorVal && (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  {" "}
                  <Icon name="alert-circle" /> Unable to login with credentials{" "}
                </Alert>
              </div>
            )}
            <Form className="is-alter" onSubmit={handleSubmit(onFormSubmit)}>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Username
                  </label>
                </div>
                <div className="form-control-wrap">
              
                   
                  <input
                    
                    id="username"
                    name="username"
                    ref={register({ required: "Username is required" })}
                    placeholder="Enter your Username"
                  
                   className={`form-control-lg form-control`}
                  />
                </div>
              </FormGroup>
              <FormGroup>
                <div className="form-label-group">
                  <label className="form-label" htmlFor="password">
                    Password
                  </label>
                  <Link className="link link-primary link-sm" to={`${process.env.PUBLIC_URL}/auth-reset`}>
                    Forgot Password?
                  </Link>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch ${passState ? "is-hidden" : "is-shown"}`}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="password"
                    name="passcode"
                    ref={register({ required: "Password is required" })}
                    placeholder="Enter your Password"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                  />
                  {errors.passcode && <span className="invalid">{errors.passcode.message}</span>}
                </div>
              </FormGroup>
              <FormGroup>
                <Button size="lg" className="btn-block" type="submit" color="primary">
                  {loading ? <Spinner size="sm" color="light" /> : "Login"}
                </Button>
              </FormGroup>
            </Form>
         
          </PreviewCard>
        </Block>
        <AuthFooter />
      </PageContainer>
    </React.Fragment>
  );
};
export default CopyLogin;
